

$(document).ready(function () {

  function submitForm(form) {
    // Override the native form submit method
    form.submit = function () {
   
      const localeEl = form.querySelector('input[name=locale_code]');
      const countryEl = form.querySelector('input[name=country_code]');
      const localeToCountry = {
        en: 'GB',
        fr: 'FR',
        de: 'DE'
      };

      if(form.id == 'HeaderLanguageFormHeader') {
        const matchedCountry = localeToCountry[localeEl.value];
        countryEl.value = matchedCountry;
      } else {
        const matchedKey = Object.entries(localeToCountry).find(
          ([key, value]) => value === countryEl.value
        )?.[0];

        localeEl.value = matchedKey;
      }
      
      //console.log(localeEl.value, countryEl.value);
      HTMLFormElement.prototype.submit.call(form);
    };
  }



  var localizationForms = document.querySelectorAll('localization-form form');
  localizationForms.forEach(form => {
    
    // Override the native form submit method
    submitForm(form);

  });

  const localeForm = document.querySelector('#HeaderLanguageFormHeader');
  const localeEl = localeForm.querySelector('input[name=locale_code]');
  const countryEl = localeForm.querySelector('input[name=country_code]');

  let localeVal = localeEl.value.toLowerCase();
  let countryVal = countryEl.value.toLowerCase();
  let countryValCheck = countryVal;
  
  if(localeVal != (countryVal == "gb" ? "en" : countryValCheck)) {
    countryVal = localeVal.toUpperCase();
    if(localeVal == "en") {
        countryVal = "GB";
    }
    countryEl.value = countryVal;
     localeForm.submit();
  }

});

